/**
 * Vehicle Gate Pass (IN / OUT) Utilities & Error Mapping
 */

export interface MarkOutPayload {
  vehicleBookingRequestId?: number | null;
  vehicleNumber: string;
  kmsOut: number;
  outDriverId?: string;
  comment?: string;
}

export interface MarkInPayload {
  vehicleBookingRequestId?: number | null;
  vehicleNumber: string;
  kmsIn: number;
  inDriverId?: string;
  comment?: string;
}

/**
 * Checks whether the API response represents a success
 * Handles both "SUCCESS" (new API format) and "S1000" (legacy format)
 */
export const isGatePassSuccess = (res: any): boolean => {
  const status = res?.data?.status;
  if (status === 'SUCCESS' || status === 'S1000') return true;
  if (res?.status === 200 && (!status || status === 200)) return true;
  return false;
};

/**
 * Maps documented API error codes to human-friendly feedback
 */
export const getGatePassErrorMessage = (err: any, fallbackMessage: string = 'Operation failed'): string => {
  const data = err?.response?.data;
  const status = data?.status || data?.errorCode;
  const description = data?.statusDescription || data?.message;

  switch (status) {
    case 'VEHICLE_NUMBER_REQUIRED':
      return 'Vehicle registration number is required.';
    case 'INVALID_KMS':
      return 'Invalid Mileage: Entered kilometers reading is less than the current vehicle mileage.';
    case 'VEHICLE_NOT_FOUND':
      return 'Vehicle not found with the specified registration plate.';
    case 'VEHICLE_ALREADY_OUT':
      return 'Vehicle is already OUT on an ongoing trip.';
    case 'VEHICLE_BOOKING_NOT_FOUND':
      return 'The specified Vehicle Booking ID does not exist.';
    case 'VEHICLE_BOOKING_INVALID_STATE':
      return 'Invalid Booking State: The booking is either not approved for departure or not ongoing for arrival.';
    default:
      return description || fallbackMessage;
  }
};
